import { Grid, Typography, colors, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader, IconAlternate } from '@/src/components/molecules';
import { CardReview } from '@/src/components/organisms';

const useStyles = makeStyles(theme => ({
  sectionHeadlineStars: {
    maxWidth: 120,
  },
  card: {
    '& .card-review__avatar': {
      width: 100,
      height: 100,
      marginRight: theme.spacing(1),
    },
  },
}));

const reviews = [
  {
    authorPhoto: {
      src: '/images/illustrations/avatars/woman-1.svg',
    },
    authorName: 'Raquel R.',
    authorOccupation: 'Cliente',
    feedback:
      'A minha compra foi super tranquila, e além disso, recebi o material rapidamente na escola. O material é muito bom, está sendo muito bem utilizado pela minha filha.',
  },
  {
    authorPhoto: {
      src: '/images/illustrations/avatars/woman-2.svg',
    },
    authorName: 'Antonia G.',
    authorOccupation: 'Cliente',
    feedback:
      'Minha experiência foi interessante, foi bom. É fácil o acesso, mesmo não tendo muito conhecimento, não tem dificuldade. O processo tem clareza, é bem tranquilo, gostei muito!',
  },
  {
    authorPhoto: {
      src: '/images/illustrations/avatars/woman-4.svg',
    },
    authorName: 'Soraia F.',
    authorOccupation: 'Cliente',
    feedback:
      'Eu achei excelente porque qualquer dúvida que a gente tem é só mandar no WhatsApp tudo certinho! É tudo muito fácil, rápido, sensacional! Eu não preciso ficar ligando na escola, posso só entrar no site e escolher o que eu quero. Facilitou muito meu dia a dia!',
  },
];

const Reviews = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <div className={className} data-aos="fade-up" {...rest}>
      <SectionHeader
        overline={
          <Image
            src="/images/illustrations/home/rated-by-our-customer.png"
            alt="rating"
            className={classes.sectionHeadlineStars}
            width="auto"
          />
        }
        title={
          <span>
            <Typography color="secondary" variant="inherit" component="span">
              Clientes satisfeitos
            </Typography>{' '}
            desde o primeiro dia!
          </span>
        }
        subtitle="Clientes que tiveram uma experiência fantástica utilizando as nossas soluções. Veja o que dizem sobre nós."
        fadeUp
      />
      <Grid container spacing={isMd ? 4 : 2}>
        {reviews.map((review, index) => (
          <Grid
            key={index.toString()}
            item
            container
            alignItems="center"
            direction="column"
            xs={12}
            sm={12}
            md={4}
            data-aos="fade-up">
            <CardReview
              variant="outlined"
              text={review.feedback}
              icon={<IconAlternate color={colors.blue} fontIconClass="fas fa-quote-right" />}
              authorName={review.authorName}
              authorTitle={review.authorOccupation}
              authorPhoto={review.authorPhoto}
              className={classes.card}
              listItemPrimaryTypographyProps={{ variant: 'h6', component: 'div' }}
              listItemSecondaryTypographyProps={{ variant: 'body1' }}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

Reviews.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Reviews;
